import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useFeedback } from '../../Hooks/Features/WelcomeKit/useFeedBack';
import { dateConvert, RenderSignatureField } from '../../utils/Helper';
import { useCommanKit } from '../../Hooks/Features/WelcomeKit/useCommanKit';


const FeedbackForm = ({ onPrev, onNext, data, readOnly }) => {
    const { documents, suggestionBodyTemplate, submittedBodyTemplate, srNoBodyTemplate, inputValues, setInputValues, handleSubmit, setIsChanged } = useFeedback({ data, onNext })
    const { signature, handleChange, handleRemove } = useCommanKit({ data });

    return (
        <div className='w100'>
            <div className='d-flex justify-content-center mx-1'>
                <div className='w100 my-2'>
                    <div>
                        <h5 className="p-2" style={{ background: "#f2f2f2" }}>Employee Feedback Form</h5>
                        <div className='d-flex justify-content-between'>
                            <div><span><b>Employee Name: </b>{data?.employee?.user_display_name}</span></div>
                            <div><span><b>Employee Id: </b>{data?.employee?.employee_id}</span></div>
                            <div><span><b> Employee Date of Joining: </b> {dateConvert(data?.employee?.joining_date, "day-mon-year")}</span></div>
                        </div>
                    </div>
                    <h5 className='my-3'>Please Provide suggestion where the rating is between 1 to 5</h5>
                    <div className='my-2'>
                        <DataTable value={documents} responsiveLayout="scroll">
                            <Column header="Sr No" body={srNoBodyTemplate} style={{ width: '60px', textAlign: 'center' }} />
                            <Column field="parameters" header="Parameters" />
                            <Column
                                field="ratting"
                                header="Rate us on 1-5 (scale:1 poor -5 Excellent)"
                                body={submittedBodyTemplate}
                                style={{ textAlign: 'center' }}
                            />
                            <Column
                                field="suggestion"
                                header="Suggestion"
                                body={suggestionBodyTemplate}
                            />
                        </DataTable>
                    </div>
                    <div>
                        <div className={`col-12 w100`}>
                            <label className="detail-label">What did you like the most ?</label><br></br>
                            <textarea name="like" className="w100" onChange={(e) => { setInputValues((prev) => ({ ...prev, like: e.target.value })); setIsChanged(true) }} value={inputValues?.like} />
                        </div>
                        <div className={`col-12 w100`}>
                            <label className="detail-label">What did you dislike ?</label><br></br>
                            <textarea name="like" className="w100" onChange={(e) => { setInputValues((prev) => ({ ...prev, disLike: e.target.value })); setIsChanged(true) }} value={inputValues?.disLike} />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                        <div>
                            Date: <b> {dateConvert(data?.employee?.joining_date, "day-mon-year")}</b>
                        </div>
                        <div>
                            {!readOnly && <RenderSignatureField name="user_signature_url" handleChange={handleChange} value={signature} handleRemove={handleRemove} lable={" Employee Signature"} />}
                        </div>

                    </div>
                    {
                        !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
                            <button className='btn-default' onClick={onPrev}>Previous</button>
                            <button className='btn-primary' onClick={handleSubmit}>Proceed</button>
                        </div>
                    }

                </div>
            </div>
        </div>
    );
};

export default FeedbackForm;
